import React from "react";
import { Button, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useIntercom } from "react-use-intercom";
import { ReactComponent as ChatSVG } from "../../../../../../../../../../../images/svg/apps/chat.svg";

const AppChatCard = () => {
	const { t } = useTranslation();
	const { show } = useIntercom();

	const launchIntercom = () => {
		show();
	};

	return (
		<Card className={"app-chat"}>
			<Card.Body>
				<div className="card-body-item">
					<ChatSVG />
					<div className="item-info">
						<span className="label">{t("modules.app.field.need_help.title")}</span>
					</div>
				</div>
				<Button type={"button"} variant={"add btn-block"} onClick={() => launchIntercom()}>
					{t("modules.app.action.launch_chat.title")}
				</Button>
			</Card.Body>
		</Card>
	);
};

export default AppChatCard;
